<script>
import {
    BCard, BRow, BCol, BAlert, BCardTitle, BCardHeader
} from 'bootstrap-vue'

export default {
    components: {
        BCard, BRow, BCol, BCardHeader, BCardTitle, BAlert,
    },
    props: {
        section: {
            required: true
        }
    }
}
</script>

<template>
    <b-row>
        <b-col>
            <b-card no-body border-variant="light">
                <b-card-header>
                    <b-card-title>{{ $t('Component(Text):comment-from-supplier') }}</b-card-title>
                </b-card-header>
                <div class="card-body">
                    <p v-if="section.informationToCustomer" style="white-space: pre-line;">
                        {{ section.informationToCustomer }}
                    </p>
                    <b-alert
                        variant="secondary"
                        :show="!section.informationToCustomer"
                    >
                        <div class="alert-body">
                            <span>{{ $t('Component(Text):no-comment-from-supplier') }}</span>
                        </div>
                    </b-alert>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>
